import React from 'react';
import { usePrefixCls } from '@byte-design/config';
export function ScheduleTitleColumn(props) {
  var datasource = props.datasource,
      title = props.title;
  var prefix = 'schedule-title-column';
  var cls = usePrefixCls(prefix);
  var titleCls = usePrefixCls(prefix, {
    title: true
  }, true);
  var itemCls = usePrefixCls(prefix, {
    item: true
  }, true);
  return React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: titleCls
  }, title), datasource.map(function (data) {
    return React.createElement("div", {
      key: data,
      className: itemCls
    }, data);
  }));
}